export const CREATING_POST = 'Creating Post';
export const RETRIEVING_POSTS = 'Retrieving Posts';
export const RETRIEVING_POST = 'Retrieving Post';
export const UPDATING_POST = 'Updating Post';
export const DELETING_POST = 'Deleting Post';
export const SEARCHING_POSTS = 'Searching Posts';
